type BrandLogoProps = {
  className?: string;
  tone?: "black" | "white";
};

export function BrandLogo({ className = "", tone = "black" }: BrandLogoProps) {
  return <img
    className={`brand-logo ${tone === "black" ? "brand-logo-black" : "brand-logo-white"} ${className}`.trim()}
    src="/brand/angelflow-logo.svg"
    alt="AngelFlow"
  />;
}
